import { axiosGet, axiosPost } from '../../axios/axios.js'
import { createFieldConfig, Store } from '../QSelectUtils.js'

export const cardPropertyObject = {
  data: function () {
    const data = {
      columnView: false,
      objectFieldConfig: null,
      componentProps: {
        url: null,
        getURL: null,
        getDependencyValue: null,
        getDependencyDisable: null,
        dialogLabel: 'ВЫБОР ОБЪЕКТОВ',
        dialogColumns: null,
        objectsMapper: null,
        filterType: null,
        formId: null,
        cached: true,
        proxy: null,
        singleModelObject: false
      }
    }
    const config = this.tabProp || this.config || {}
    if (config.componentProps) {
      data.componentProps = Object.assign(data.componentProps, config.componentProps)
    }
    this.enrichComponentProps(data.componentProps)

    data.multiple = config.type === 'objects' || config.type === 'sysobjects'
    if (data.componentProps.url || data.componentProps.getURL) {
      data.objectFieldConfig = createFieldConfig({
        allRecordsFn: this.getAvailableObjects,
        cached: data.componentProps.cached,
        storeType: 'server'
      })
    } else {
      const vm = this
      const proxy = data.componentProps.proxy ? data.componentProps.proxy : {
        urlBase: data.componentProps.filterType ? '/service/delta/obj/search' : '/service/obj/search',
        searchParamKey: data.componentProps.filterType ? null : 'name', // !!!
        searchCustom: false, // !!!
        filterType: data.componentProps.filterType,
        formId: data.componentProps.formId,
        get urlParams () {
          return vm.searchParams
        },
        get mapper () {
          return vm.componentProps.objectsMapper
        }
      }

      data.objectFieldConfig = createFieldConfig(new Store({
        fullReadable: false,
        searchable: false,
        cached: data.componentProps.cached,
        proxy: proxy,
        itemsFn: function () {
          // TODO const proxy = this.proxy
          const urlParams = new URLSearchParams()

          urlParams.append('limit', 20)
          urlParams.append('start', 0)

          if (proxy.filterType) {
            urlParams.append('filterType', proxy.filterType)
          }
          if (proxy.formId) {
            urlParams.append('formId', proxy.formId)
          }
          // if (sortBy) {
          //   urlParams.append('sort', sortBy)
          //   urlParams.append('dir', descending ? 'DESC' : 'ASC')
          // }
          if (proxy.urlParams) {
            Object.entries(proxy.urlParams).forEach(([key, value]) => urlParams.append(key, value))
          }
          // if (proxy.searchParamKey && this.searchFieldText) {
          //   console.log('search: ' + this.searchFieldText)
          //   urlParams.append(proxy.searchParamKey, this.searchFieldText)
          // }

          const url = proxy.urlBase + //
            (proxy.urlBase.includes('?') ? '&' : '?') + //
            urlParams.toString()

          let bodyFormData = null
          if (proxy.post && proxy.bodyParams) {
            bodyFormData = new FormData()
            for (const [key, value] of Object.entries(proxy.bodyParams)) {
              bodyFormData.set(key, value)
            }
          }

          const requestFn = proxy.post ? axiosPost : axiosGet
          return requestFn({
            url: url,
            data: bodyFormData,
            onSuccess: (response) => {
              const rowsNumber = response.data.total != null ? response.data.total : response.data.count != null ? response.data.count : response.data.result.length
              console.log('Total: ' + rowsNumber)

              let data = response.data.result
              if (proxy.mapper) {
                data = data.map(proxy.mapper)
              }
              return data
            },
            onFailure: 'Ошибка при загрузке данных',
            msgTarget: this
          })
        }
      }))
    }
    return data
  },
  computed: {
    dialogColumns: function () {
      return this.componentProps && this.componentProps.dialogColumns || null
    },
    searchParams: function () {
      if (this.tabProp) {
        const params = {}
        if (this.tabProp.objectchooseroot) {
          const root = this.tabProp.objectchooseroot[0]
          params.root = 'root.' + root.key
        }
        if (this.tabProp.objectchoosetypes && this.tabProp.objectchoosetypes.length) {
          params.type = this.tabProp.objectchoosetypes.map(o => o.id).join(',')
        }
        params.subtypes = this.tabProp.objectchoosesubtypes // this.tabProp.subtype
        params.fulltext = this.componentProps.fulltext || false

        const columns = this.dialogColumns
        if (columns && columns.length) {
          const additionalProperties = columns.map(column => column.srcField || column.field || column.name).filter(propertyName => propertyName && propertyName !== 'name')
          if (additionalProperties.length) {
            params.add = additionalProperties.join(',')
          }
        }

        return params
      }
      return null
    }
  },
  methods: {
    enrichComponentProps: function (componentProps) { // @Default
    },
    getAvailableObjects: function () {
      let promise = axiosGet({
        url: this.componentProps.url || this.componentProps.getURL(this.object),
        onSuccess: (response) => {
          if (this.componentProps.responseKeyAvailableObjects) {
            return response.data.result[this.componentProps.responseKeyAvailableObjects]
          } else {
            return response.data.result
          }
        },
        onFailure: 'Ошибка получения списка допустимых значений для поля ' + this.tabProp._nameUpperCase,
        throws: true
      })
      if (this.componentProps.objectsMapper) {
        promise = promise.then(items => {
          if (items && items.length) {
            items = items.map(this.componentProps.objectsMapper)
          }
          return items
        })
      }
      return promise
    },
    getSystemTree: function (rootId) {
      const rootIdParts = rootId.split('.')
      const treeKey = rootIdParts[rootIdParts.length - 1]
      const treeRoot = this.$store.getters.getSystemTreeRoot('objectstrees')

      axiosGet({
        url: '/service/sysobj/tree?id=' + treeRoot.id + '&rel=' + treeRoot.choosetypes.join(','),
        onSuccess: (response) => {
          // TODO
        },
        onFailure: 'Ошибка'
      })
    }
  }
}
